var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeciality11(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e,.f{fill:#fff;}.a{stroke:#707070;}.b{clip-path:url(#a);}.c,.d,.h{fill:none;}.c,.d,.e,.f{stroke:#208ce1;stroke-width:1.5px;}.c,.d,.f{stroke-linecap:round;}.d,.f{stroke-linejoin:round;}.g{stroke:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-664 -7430)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(664 7430)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-651.316-7382.23v-4.9s-3.228-2.554-3.719-5.633-.312-18.119-.312-18.119,1.473-4.239,5.489-1.2a7.662,7.662,0,0,1,1.737-2.111c.842-.7,2.409-.962,4.278.923l.2.176c1.55-4.974,4.718-2.4,6-1.646-.044-5.36-.254-10.292-.254-10.292s-.391-3.8,3.035-3.838,3.169,4.909,3.169,4.909"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-643.535-7395.471s1.424-7.136,10.822-6.788c5.4-7.252,4.475-6.19,5.976-7.948s4.815-2.9,5.163.87-4.583,9.457-4.583,9.457a61.841,61.841,0,0,1-7.774,11.95v5.627"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-655.169-7405s3.347,3.793,5.534-.268c.134-4.775,0-6.783,0-6.783"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-650 -7416)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 7,
    height: 13,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 0.75,
    y: 0.75,
    width: 5.5,
    height: 11.5,
    rx: 2.75
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-644 -7417)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 7,
    height: 14,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 0.75,
    y: 0.75,
    width: 5.5,
    height: 12.5,
    rx: 2.75
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-656 -7414)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 7,
    height: 11,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 0.75,
    y: 0.75,
    width: 5.5,
    height: 9.5,
    rx: 2.75
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M9.188,4.035,11.44,6.31a3.239,3.239,0,0,1,0,4.548,3.159,3.159,0,0,1-4.5,0,3.239,3.239,0,0,1,0-4.548Z",
    transform: "translate(-640.881 -7425.801)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-631.691-7412.716v3.485",
    transform: "translate(0 1.215)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality11);
export default __webpack_public_path__ + "static/media/speciality11.73fa7d2cc3e64218065dd78809b91951.svg";
export { ForwardRef as ReactComponent };